<template>
  <div class="custom-table-container">
    <table class="table table-custom-header">
      <thead>
        <tr>
          <th class="sticky-col">{{ __("views.KPIAssociation.survey_question") }}</th>
          <th
            v-if="this.columnSelectOption.length > 0"
            class="sticky-header"
          >
            {{ __("misc.answer") }}
          </th>
          <th style="min-width:150px"
            class="matrix-center-element sticky-header"
            v-for="column in columnNonSelectOption"
            v-bind:key="column.id"
          >
            {{ column.column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index_r) in rows" :key="index_r">
          <th class="sticky-col">
            {{ row.label }}
          </th>
          <td style="min-width:150px"
            class="matrix-width matrix-center-element"
            v-if="columnSelectOption.length > 0"
          >
            <div v-if="row.edit > 1">
              <select
                class="form-control"
                :class="'saveQuestion ' + row.classRequired"
                :name="'question['+question_survey_id +']['+index_r+'][select]'">
                <option></option>
                <option
                  v-for="column in columnSelectOption"
                  v-bind:key="column.id"
                  :selected="
                    answers_list[index_r]['select'] != '' &&
                    answers_list[index_r]['select'] == column.id &&
                    !empty_values
                  "
                  :value="column.id"
                  Evaluations="answers_list[index_r]"
                >
                  {{ column.column.label }}
                </option>
              </select>
            </div>
            <div v-if="row.edit <= 1">
              <span>
                {{
                  getAnswerDescriptionFromAnswerId(
                    answers_list[index_r]["select"],
                    columnSelectOption,
                  )
                }}
              </span>
            </div>
          </td>
          <td
            class="matrix-width matrix-center-element"
            v-for="column in columnNonSelectOption"
            v-bind:key="column.id"
          >
            <div v-if="row.edit == 1">
              <div v-if="column.column.type == 'radio'">
                <span v-if="answers_list[index_r]['radio'] == column.id">
                  <i style="color: #2A9D8F" class="fa-solid fa-circle-check"></i>
                </span>
              </div>
              <div v-else>
                <span
                  v-if="
                    answers_list[index_r][column.id] &&
                    column.column.type == 'checkbox'
                  "
                >
                <i style="color: #2A9D8F" class="fa-solid fa-circle-check"></i>
                </span>
                <span v-else>
                  {{ answers_list[index_r][column.id] }}
                </span>
              </div>
            </div>
            <div v-else-if="row.edit > 1">
              <!-- {{ column.column.type }} -->
                <input
                    v-if="column.column.type == 'radio'"
                    :type="column.column.type"
                    :value="column.id"
                    :class="'saveQuestion custom-radio ' + row.classRequired"
                    v-model="answers_list[index_r]['radio']"
                    :name="
                  'question[' + question_survey_id + '][' + index_r + '][radio]'
                "
                />
              <div v-else-if="column.column.type == 'checkbox'">
                <input type='hidden' value='' :name="'question[' +question_survey_id +'][' +index_r +'][' +column.id +']'">
                <input
                    :type="column.column.type"
                    :class="' saveQuestion custom-checkbox ' + row.classRequired"
                    v-model="answers_list[index_r][column.id]"
                    :name="'question[' +question_survey_id +'][' +index_r +'][' +column.id +']'
                "
                />
              </div>
              <div v-else-if="column.column.type == 'date'">
                <input
                    :type="column.column.type"
                    :class="' saveQuestion form-control ' + row.classRequired"
                    v-model="answers_list[index_r][column.id]"
                    :name="
                  'question[' +
                  question_survey_id +
                  '][' +
                  index_r +
                  '][' +
                  column.id +
                  ']'
                "
                />
              </div>
              <textarea
                v-else
                rows="1"
                :class="' saveQuestion form-control ' + row.classRequired"
                v-model="answers_list[index_r][column.id]"
                :name="
                  'question[' +
                  question_survey_id +
                  '][' +
                  index_r +
                  '][' +
                  column.id +
                  ']'
                "
              ></textarea>
              <!-- <input
                v-else
                :type="column.column.type"
                :class="' saveQuestion form-control ' + row.classRequired"
                v-model="answers_list[index_r][column.id]"
                :name="
                  'question[' +
                  question_survey_id +
                  '][' +
                  index_r +
                  '][' +
                  column.id +
                  ']'
                "
              /> -->
            </div>
            <div v-else>altro</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  width: 100%;
}

.table-custom-header thead tr th {
  background: transparent;
  color: #1767A2 !important;
  font-weight: 800 !important;
}

.custom-table-container {
  padding-right: 20px;
  width: 100%;
  overflow-x: auto;
  max-height: 80vh; 
  overflow-y: auto; 
}

.custom-radio,
.custom-checkbox {
  width: 22px;
  height: 22px;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  background-color: white !important;
  z-index: 3; 
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.5); 
  min-width:200px !important;
}

.sticky-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: white !important;
  z-index: 2;
}

</style>

<script>
export default {
  mounted() {
    this.answers_list = this.answers;
    this.columnSelectOption = this.getSelectOptions(this.columns);
    this.columnNonSelectOption = this.getNonSelectOptions(this.columns);
  },
  props: {
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    key_rows: {
      type: Array,
      required: true,
    },
    rows: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    answers: {
      type: Object,
      required: true,
    },
    empty_values: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      answers_list: [],
      columnSelectOption: [],
      columnNonSelectOption: [],
      action: "",
      editing: true,
     
    };
  },
  methods: {
    getSelectOptions(columns) {
      var options = [];
      if (columns != null && columns.length > 0) {
        for (var i = 0; i < columns.length; i++) {
          if (columns[i].type == "select") {
            var option = {
              id: i,
              column: columns[i],
            };
            options.push(option);
          }
        }
      }
      return options;
    },
    getNonSelectOptions(columns) {
      var options = [];
      if (columns != null && columns.length > 0) {
        for (var i = 0; i < columns.length; i++) {
          if (columns[i].type != "select") {
            var option = {
              id: i,
              column: columns[i],
            };
            options.push(option);
          }
        }
      }
      return options;
    },
    getAnswerDescriptionFromAnswerId(answerId, listDescription) {
      if (listDescription == null) {
        return null;
      }

      if (listDescription.length === 0) {
        return null;
      }

      if (answerId == null || answerId == "") {
        return null;
      }

      var description = null;

      for (var i = 0; i < listDescription.length; i++) {
        if (listDescription[i].id == answerId) {
          description = listDescription[i].column.label;
          break;
        }
      }

      return description;
    },
  },
};
</script>
